import { DataList } from "@chakra-ui/react"
import React from 'react';


const ExtractedDataList = ({ listData }: { listData: { label: string; value: any}[] }) => {

    return (
      <DataList.Root orientation="horizontal">
        {listData.map((item) => (
          <DataList.Item key={item.label}>
            <DataList.ItemLabel>{item.label}</DataList.ItemLabel>
            <DataList.ItemValue>{item.value ?? "-"}</DataList.ItemValue>
          </DataList.Item>
        ))}
      </DataList.Root>
    )
}



export default ExtractedDataList;